var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.57 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3e9d7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "indesign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-.57,0V60.05H61.06V0ZM2,2.53H58.48V57.47H2ZM22,41.62c0,.24,0,.33-.33.33h-4a.29.29,0,0,1-.33-.33V14c0-.25.13-.35.33-.35h4c.21,0,.29.1.29.31V41.62Zm4.56-10c0-6.13,4-10.93,10.53-10.93.55,0,.85,0,1.36,0V14a.25.25,0,0,1,.24-.26h4.18c.22,0,.26.1.26.22v24a17.55,17.55,0,0,0,.14,2.58c0,.16-.06.2-.22.3a15.78,15.78,0,0,1-6.74,1.52c-5.71,0-9.76-3.51-9.75-10.67Zm11.89-6.72a3.81,3.81,0,0,0-1.52-.26c-3.3,0-5.62,2.53-5.62,6.78,0,4.83,2.36,6.77,5.33,6.77a4.83,4.83,0,0,0,1.82-.3v-13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesign);
export default __webpack_public_path__ + "static/media/indesign.fc98d51a55d2d025665e41eebd6dc728.svg";
export { ForwardRef as ReactComponent };